import { WidgetUnit } from 'types';
import { AppTrackingEvent } from './types';

export function isSponsored(
  resultId: string,
  units: Record<string, WidgetUnit>,
): boolean {
  return units[resultId]?.isSponsored;
}

export function isUnitEvent(
  event: AppTrackingEvent,
): event is Extract<AppTrackingEvent, { payload: { resultId: string } }> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return typeof (event as any)?.payload?.resultId === 'string';
}
